import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (17.936 / 24);
  const localHeight = size * (18 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 17.936 18">
      <path
        d="M8.193,17.884a.617.617,0,0,1-.242-.637L8.4,15.254H.618A.618.618,0,0,1,0,14.637V.618A.618.618,0,0,1,.618,0h11.6a.618.618,0,0,1,.618.618V8.281l2.015-2.807a.618.618,0,0,1,.862-.142l1.964,1.409a.618.618,0,0,1,.142.862L11.7,16.134a.611.611,0,0,1-.181.167L8.875,17.91a.617.617,0,0,1-.682-.026Zm1.614-3.262L9.475,16.1l1.292-.786,5.689-7.926L15.5,6.7Zm-8.572-.6H8.72L8.73,14l2.878-4.009A.625.625,0,0,1,11.6,9.91V1.236H1.236Zm2.282-2.67a.579.579,0,1,1,0-1.158h5.8a.579.579,0,1,1,0,1.158Zm0-3.223a.579.579,0,0,1,0-1.158h5.8a.579.579,0,0,1,0,1.158Zm0-3.223a.579.579,0,1,1,0-1.158h5.8a.579.579,0,1,1,0,1.158Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
